// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Globe, Mail, Settings } from "lucide-react";

// Automated actions per stage (`automated_actions_count`). Without the field
// from the API this renders "—", not 0: a zero would claim every step is manual.
export const ActionCount = ({ value }) =>
  typeof value === "number" ? (
    value
  ) : (
    <span title="Die API liefert diese Zählung noch nicht.">—</span>
  );

const StatusCard = ({
  status,
  isSelected,
  onClick,
  colorMap,
  apiCount = 0,
  emailCount = 0,
  actionCount = null,
}) => {
  return (
    <div
      className={`border-2 rounded-xl md:p-4 p-3 cursor-pointer transition-all duration-200 ${
        isSelected
          ? "border-primary-color bg-gradient-primary-secondary-tint shadow-lg"
          : "border-slate-200 dark:border-slate-600 hover:border-slate-300 dark:hover:border-slate-500 bg-white dark:bg-slate-700/50 hover:shadow-md"
      }`}
      onClick={onClick}
    >
      <div className="flex justify-between items-start mb-3">
        <div>
          <h3 className="font-semibold text-slate-900 dark:text-slate-100">
            {status.status_name}
          </h3>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
            {status.description}
          </p>
          <div className="flex items-center gap-2 mt-2">
            <span
              className={`px-2 py-1 rounded-lg text-xs font-medium border ${colorMap[status.color_code] || "bg-slate-100 dark:bg-slate-600 text-slate-800 dark:text-slate-200 border-slate-200 dark:border-slate-500"}`}
            >
              {status.color_code}
            </span>
            {status.is_system_status && (
              <span className="px-2 py-1 rounded-lg text-xs font-medium bg-primary-color-tint primary-color border border-primary-color">
                System
              </span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded-full bg-green-400 dark:bg-green-500"></span>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-500 dark:text-slate-400">
        <span className="flex items-center gap-1">
          <Globe className="w-3 h-3" />
          {apiCount} API-Aufrufe
        </span>
        <span className="flex items-center gap-1">
          <Mail className="w-3 h-3" />
          {emailCount} Benachrichtigungen
        </span>
        <span className="flex items-center gap-1">
          <Settings className="w-3 h-3" />
          <ActionCount value={actionCount} /> Aktionen
        </span>
      </div>
      <div className="mt-3 pt-3 border-t border-slate-200 dark:border-slate-600">
        <div className="text-xs text-slate-500 dark:text-slate-400">
          Position: #{status.position} | Code: {status.status_code}
        </div>
      </div>
    </div>
  );
};

export default StatusCard;
